/* React components */
import { useState } from "react";
/* Custom hooks */
import { validateField, validateEmail } from "./useValidation";
/* Formularios para renderizar */
import FormUTH from "../user_uth";
import FormFinancieras from "../user_financieras/index";
import FormCPN from "../user_cpn/index";

// Librerías
import React, { StrictMode } from "react";
import ReactDOM from "react-dom";

const isEmpty = (obj) => Object.keys(obj).length === 0;

const useForm = ({
  //Declaración de funciones
  initialValues,
  validationSchema,
  validate,
  validateOnChange = true,
  validateAllFields = false,
  onSubmit,
}) => {
  const [values, setValues] = useState(initialValues),
    [errors, setErrors] = useState({}),
    getRulesSchema = validationSchema ? Object.values(validationSchema) : [],
    getPropertiesNameSchema = validationSchema
      ? Object.getOwnPropertyNames(validationSchema)
      : [],
    getPropertiesValues = Object.getOwnPropertyNames(initialValues),
    runValidationRules = (property, value) => {
      let result;
      if (validationSchema[property].isEmail) {
        const existMaxRule = validationSchema[property].max;
        const max = existMaxRule && existMaxRule.limit;
        result = validateEmail({
          value,
          required: validationSchema[property].required,
          max,
          validEmail: validationSchema[property].validEmail,
          validDns: validationSchema[property].validDns,
          shortValue:
            existMaxRule &&
            (typeof existMaxRule.message === "function"
              ? existMaxRule.message(max)
              : existMaxRule.message),
        });
      } else {
        const existMinRule = validationSchema[property].min;
        const existMaxRule = validationSchema[property].max;
        const max = existMaxRule && existMaxRule.limit;
        const min = existMinRule && existMinRule.limit;
        result = validateField({
          name: property,
          value,
          required: validationSchema[property].required,
          min,
          max,
          shortValue:
            existMinRule &&
            (typeof existMinRule.message === "function"
              ? existMinRule.message(min)
              : existMinRule.message),
          maxValue:
            existMaxRule &&
            (typeof existMaxRule.message === "function"
              ? existMaxRule.message(max)
              : existMaxRule.message),
        });
      }

      return result;
    },
    runValidationSchema = (result) => {
      setErrors(result);
      isEmpty(result) &&
        onSubmit({
          values,
          resetForm,
        });
    },
    deleteUndefinedErrors = (result, property) => {
      if (isEmpty(result)) {
        const deleteProperty = { ...errors };
        delete deleteProperty[property];
        !isEmpty(errors) && setErrors(deleteProperty);
      } else {
        setErrors({ ...errors, [property]: result[property] });
      }
    },
    runValidationErrors = ({ property, value, allValues }) => {
      const getErrors = validateAllFields
        ? validate(allValues)
        : validate(property, value);
      return getErrors;
    },
    runValidateAllFields = () => {
      let result;
      if (validationSchema) {
        result = getRulesSchema.reduce((acc, _, i) => {
          const property = getPropertiesNameSchema[i];
          const getValidationResult = runValidationRules(
            property,
            values[property]
          );
          return { ...acc, ...getValidationResult };
        }, {});
      } else if (validate) {
        result = getPropertiesValues.reduce((acc, property) => {
          // const getErrors = validate(property, values[property]);
          const getErrors = runValidationErrors({
            property,
            value: values[property],
            allValues: values,
          });
          return { ...acc, ...getErrors };
        }, {});
      }
      // this.props.setValues(this.state.name, this.state.email);
      runValidationSchema(result);
    },
    setFieldValue = (property, value) => {
      let deleteErrors;
      const fieldValue = { ...values, [property]: value };
      setValues(fieldValue);
      if (validateOnChange) {
        if (validationSchema) {
          deleteErrors = runValidationRules(property, value);
        } else if (validate) {
          const getErrors = runValidationErrors({
            property,
            value,
            allValues: fieldValue,
          });
          deleteErrors = getErrors;
          typeof getErrors === "object" && setErrors(getErrors);
        }
      }
      deleteUndefinedErrors(deleteErrors, property);
    },
    handleSubmit = (property, resp) => {
      property.preventDefault();
      const emailDomain = property.target.email.value.split('@')[1];
      let company = '';
      // Verificar el dominio del correo electrónico y asignar la compañía correspondiente
      if (emailDomain === 'prestaya.hn') {
        company = 'PrestaYa';
      } else if (emailDomain === 'prestaauto.hn') {
        company = 'PrestaAuto';
      } else if (emailDomain === 'credimovil.hn') {
        company = 'CrediMovil';
      } else if (emailDomain === 'credirapid.hn') {
        if (property.target.email.value.toLowerCase().includes('sps')) {
          company = 'COGASA';
        } else {
          company = 'CrediRapid';
        }
      } else if (emailDomain === 'mersa.hn') {
        company = 'Mersa';
      } else if (emailDomain === 'compresa.hn') {
        company = 'Compresa';
      } else if (emailDomain === 'credibodega.hn') {
        company = 'CrediBodega';
      } else if (emailDomain === 'inversa.hn') {
        company = '';
      }


      if (property.target.email.value.split("@")[1] === "uth.hn") {
        const main = document.getElementsByTagName("main")[0];
        ReactDOM.render(
          <StrictMode>
            <FormUTH
              name={property.target.name.value}
              email={property.target.email.value}
              resp={resp}
            />
          </StrictMode>,
          main
        );
      } else if (property.target.email.value.split("@")[1] === "cpn.hn") {
        const main = document.getElementsByTagName("main")[0];
        ReactDOM.render(
          <StrictMode>
            <FormCPN
              name={property.target.name.value}
              email={property.target.email.value}
            />
          </StrictMode>,
          main
        );
      } else {
        const main = document.getElementsByTagName("main")[0];
        ReactDOM.render(
          <StrictMode>
            <FormFinancieras
              name={property.target.name.value}
              email={property.target.email.value}
              company={company}
            />
          </StrictMode>,
          main
        );
      }
      return runValidateAllFields();
    },
    resetForm = () => {
      setValues(initialValues);
      setErrors({});
    };

  return {
    values,
    setFieldValue,
    errors,
    handleSubmit,
    resetForm,
  };
};

export default useForm;
